module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0118.jpg?v=9388a590";